/* global Swiper */

/**
 * Cross-sell carousel for the cart - drawer and cart page.
 *
 * Swiper (global, loaded in layout/theme.liquid) rather than the stock
 * <carousel-slider>: that element defers its init to an IntersectionObserver, and
 * the drawer sits off-canvas until opened, so it never initialised - dead nav
 * buttons and stale disabled states. Swiper measures on demand.
 *
 * Markup: snippets/cart-upsells.liquid. Slides per view and gaps come from data
 * attributes so the two contexts can differ.
 */
(() => {
  const SELECTOR = '[data-cart-upsell-carousel]';
  const instances = new WeakMap();

  function num(value, fallback) {
    const parsed = parseFloat(value);
    return Number.isNaN(parsed) ? fallback : parsed;
  }

  function init(el) {
    if (typeof Swiper === 'undefined') return;

    const existing = instances.get(el);
    if (existing) {
      // Same element, contents may have changed - re-measure rather than rebuild.
      existing.update();
      return;
    }

    const root = el.closest('.cart-upsells') || el.parentElement;

    instances.set(
      el,
      new Swiper(el, {
        slidesPerView: num(el.dataset.slidesMobile, 1.75),
        spaceBetween: num(el.dataset.gapMobile, 10),
        breakpoints: {
          768: {
            slidesPerView: num(el.dataset.slidesDesktop, 1.75),
            spaceBetween: num(el.dataset.gapDesktop, 10)
          }
        },
        grabCursor: true,
        // Locks the nav (and adds .swiper-button-lock) when everything already fits.
        watchOverflow: true,
        // The cart re-renders its contents on cart changes.
        observer: true,
        observeParents: true,
        navigation: {
          prevEl: root.querySelector('[data-upsell-prev]'),
          nextEl: root.querySelector('[data-upsell-next]')
        }
      })
    );
  }

  function initAll() {
    document.querySelectorAll(SELECTOR).forEach(init);
  }

  // Cart page: the carousel is on screen from the start.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Drawer: only measurable once open. Both events bubble to document
  // (see assets/custom.js for the event reference).
  document.addEventListener('on:cart-drawer:after-open', initAll);
  document.addEventListener('on:cart:after-merge', initAll);
})();
